<script>
export default {
  name: 'UserTariff',
  props: {
    id: Number,
    label: String,
  },
};
</script>

<template lang="pug">
  .tariff(:class="`tariff-${id}`") {{ label }}
</template>

<style scoped lang="scss">
.tariff {
  box-sizing: border-box;
  padding: 0 15px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  font-weight: 500;
  font-family: Geometria, sans-serif;
  font-size: 12px;
  font-style: normal;
  line-height: 12px;
  letter-spacing: 0.12px;
  width: 100%;
  text-align: center;
}

.tariff-1 {
  background: rgba(255, 220, 179, 1);
  color: rgba(255, 138, 1, 1);
}

.tariff-2 {
  background: rgba(246, 208, 214, 1);
  color: rgba(240, 37, 51, 1);
}

.tariff-3 {
  background: rgba(199, 234, 219, 1);
  color: rgba(0, 154, 71, 1);
}

.tariff-4 {
  background: rgba(248, 237, 178, 1);
  color: rgba(246, 177, 0, 1);
}

.tariff-5 {
  background: rgba(53, 125, 237, 0.2);
  color: rgba(53, 125, 237, 1);
}

.tariff-6 {
  background: rgba(204, 246, 255, 1);
  color: rgba(2, 202, 246, 1);
}
</style>
